import {
    TLoadable,
    createUnloaded,
    createLoading,
    createLoaded,
    createLoadErrored,
} from "../../../../sg-core";
import { TAuthAction } from "./authActions";
import IHavainnotUser from "../../interfaces/IHavainnotUser";
import { default as JSCookies } from "js-cookie";

export enum AuthenticationType {
    GateUser = "GateUser",
    AnonToken = "AnonToken",
}

export interface IHav20AuthState {
    authenticationStatus: TLoadable<AuthenticationType>;
    token: string | null;
    loggedInUserId: number | null;
    loggedInUser: IHavainnotUser | null;
    appRoles: TLoadable<string[]>;
    logoutCounter: number;

    anonPackage?: any;
    returnHref: string | null;
    lang?: string;
    rdr: string | null;
}

export const defaultAuthState: IHav20AuthState = {
    authenticationStatus: createLoading(),
    token: null,
    loggedInUserId: null,
    loggedInUser: null,
    appRoles: createUnloaded(),
    logoutCounter: 0,
    returnHref: null,
    rdr: JSCookies.get("rdr") || null,
};

const authReducer = (state = defaultAuthState, action: TAuthAction): IHav20AuthState => {
    switch (action.type) {
        case "REQUEST_LOGIN": {
            return {
                ...state,
                authenticationStatus: createLoading(),
            };
        }
        case "REQUEST_INITIALIZE_LOGIN": {
            return { ...state, authenticationStatus: createLoading() };
        }

        case "SET_LANGUAGE": {
            return {
                ...state,
                lang: action.payload.language,
            };
        }

        case "SUCCESS_LOGIN": {
            return {
                ...state,
                authenticationStatus: createLoaded(AuthenticationType.GateUser),
                loggedInUserId: action.payload.user.id,
                loggedInUser: action.payload.user,
                token: action.payload.sid,
                returnHref: action.payload.returnHref,
                lang: action.payload.lang,
            };
        }
        case "SUCCESS_GATE_LOGIN": {
            return {
                ...state,
                authenticationStatus: createLoaded(AuthenticationType.GateUser),
                loggedInUserId: action.payload.user.id,
                loggedInUser: action.payload.user,
                token: action.payload.sid,
                returnHref: action.payload.returnHref,
                lang: action.payload.lang,
                rdr: action.payload.rdr || null,
            };
        }

        case "SUCCESS_ANON_LOGIN": {
            return {
                ...state,
                authenticationStatus: createLoaded(AuthenticationType.AnonToken),
                token: action.payload.sid,
                anonPackage: action.payload.data,
            };
        }

        case "FAILURE_LOGIN": {
            return {
                ...state,
                authenticationStatus: createLoadErrored(action.error),
                loggedInUserId: null,
                loggedInUser: null,
                token: null,
                logoutCounter: state.logoutCounter + 1,
            };
        }

        case "LOGOUT": {
            return {
                ...state,
                authenticationStatus: createUnloaded(),
                loggedInUserId: null,
                loggedInUser: null,
                token: null,
                logoutCounter: state.logoutCounter + 1,
            };
        }

        case "REQUEST_FETCH_USERS_APP_ROLES": {
            return { ...state, appRoles: createLoading() };
        }

        case "SUCCESS_FETCH_USERS_APP_ROLES": {
            return { ...state, appRoles: createLoaded(action.payload.roles) };
        }

        case "FAILURE_FETCH_USERS_APP_ROLES": {
            return { ...state, appRoles: createLoadErrored(action.payload.error) };
        }

        case "SET_APP_ROLES": {
            return { ...state, appRoles: createLoaded(action.payload.roles) };
        }
    }
    return state;
};

export default authReducer;
